class Texture {
    constructor(resId, callBack, mouseMoveCallBack, pathProgressCallBack) {
        this.dataSetId = resId;
        this.callBack = callBack;
        this.mouseMoveCallBack = mouseMoveCallBack;
        this.pathProgressCallBack = pathProgressCallBack;

        this.pipeId = "";
        this.hugeMBlockNumMax = 0;      // 用于计算中心线生成进度
        this.currProgress = 0;          // 用于计算中心线生成进度

        this.onAddPipeSuccess = this.onAddPipeSuccess.bind(this);
        this.onPipeCenterLineProgress = this.onPipeCenterLineProgress.bind(this);

        this.onCanvasMouseMove = this.onCanvasMouseMove.bind(this);
    }

    addEventListener() {
        document.addEventListener("REAddContPipeSuccessEvent", this.onAddPipeSuccess);
        document.addEventListener("REGenPipeCenterLineProgress", this.onPipeCenterLineProgress);

        let dom = document.getElementById('engineCanvas');
        dom.addEventListener("mousemove", this.onCanvasMouseMove);
    }

    removeEventListener() {
        document.removeEventListener("REAddContPipeSuccessEvent", this.onAddPipeSuccess);
        document.removeEventListener("REGenPipeCenterLineProgress", this.onPipeCenterLineProgress);

        let dom = document.getElementById('engineCanvas');
        dom.removeEventListener("mousemove", this.onCanvasMouseMove);
    }

    start() {
        this.addEventListener();

        let BlackHole3D = window.BlackHole3D;
        BlackHole3D.Pipe.startEditContPipeMode();
        BlackHole3D.Pipe.setCurContPipe(this.pipeId);

        BlackHole3D.Graphics.setSysUIPanelVisible(false);
    }

    createTexture() {
        let pipeId = new Date().getTime() + '';
        this.pipeId = pipeId;

        this.start();
    }

    editTexture(texInfo) {
        let BlackHole3D = window.BlackHole3D;
        BlackHole3D.Pipe.delContPipe([]);

        this.pipeId = texInfo.id;
        let pipeInfo = new BlackHole3D.REPipeInfo();
        pipeInfo.dataSetId = this.dataSetId;
        pipeInfo.pipeId = texInfo.id;
        pipeInfo.elemIdList = texInfo.elements;
        // pipeInfo.texPath = texInfo.imageSrc;
        // pipeInfo.pipeClr = texInfo.pipeClr;
        BlackHole3D.Pipe.addContPipe(pipeInfo);

        this.start();
    }

    onAddPipeSuccess() {
        let BlackHole3D = window.BlackHole3D;
        BlackHole3D.Pipe.saveCurContPipe();
        BlackHole3D.Pipe.setGenContPipeCenterLine([this.pipeId]);

        let eventInfo = {
            visible: true, percentage: 0
        }
        this.pathProgressCallBack(eventInfo);
    }

    onPipeCenterLineProgress(e) {
        let hugeMBlockNum = e.detail.hugeMBlockNum;
        let progress = this.calcProgress(hugeMBlockNum);
        let BlackHole3D = window.BlackHole3D;
        if (progress === 100) {
            let xmlString = BlackHole3D.Pipe.getContPipeInfoXMLStr([this.pipeId]);
            // console.log(xmlString, "路径");
            let pipeInfo = this.analysisXMLString(xmlString);
            // this.drawCenterLine(pipeInfo)

            this.removeEventListener();
            BlackHole3D.Pipe.endEditContPipeMode();
            this.callBack(pipeInfo);

            BlackHole3D.Graphics.setSysUIPanelVisible(true);

            // 绘制结束时关闭鼠标跟随提示
            let eventInfo = { clientX: 0, clientY: 0 };
            this.onCanvasMouseMove(eventInfo);


            let progressInfo = {
                visible: false, percentage: 0
            }
            this.pathProgressCallBack(progressInfo);
        } else {
            let progressInfo = {
                visible: true, percentage: progress
            }
            this.pathProgressCallBack(progressInfo);
        }
    }
    analysisXMLString(xmlString) {
        let pipeInfo = {
            dataSetId: this.dataSetId,
            pipeId: this.pipeId
        };

        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(xmlString, "text/xml");
        let rootElement = xmlDoc.documentElement;
        let contPipe = rootElement.getElementsByTagName("ContPipe")[0];
        let points = contPipe.getElementsByTagName("Point");
        let elems = contPipe.getElementsByTagName("Elem");
        let pathPoints = [];
        for (let i = 0; i < points.length; i++) {
            let point = points[i];

            let x = Number(point.getAttribute('X'));
            let y = Number(point.getAttribute('Y'));
            let z = Number(point.getAttribute('Z'));
            pathPoints.push({ x, y, z });
        }
        pathPoints = JSON.stringify(pathPoints);

        let elements = [];
        for (let i = 0; i < elems.length; i++) {
            let elem = elems[i];
            let elementIntId = elem.getAttribute('ID');
            let indexNum = i;
            let anchorPoint = [];
            let x = Number(elem.getAttribute('X'));
            let y = Number(elem.getAttribute('Y'));
            let z = Number(elem.getAttribute('Z'));
            anchorPoint = JSON.stringify({ x, y, z });
            let obj = {
                elementIntId,
                indexNum,
                anchorPoint
            }
            elements.push(obj);
        }

        pipeInfo.points = pathPoints;
        pipeInfo.elements = elements;
        return pipeInfo;
    }

    end() {
        document.removeEventListener("REAddContPipeSuccessEvent", this.onAddPipeSuccess);
        document.removeEventListener("REGenPipeCenterLineProgress", this.onPipeCenterLineProgress);
    }

    drawCenterLine(pipeInfo) {
        let points = JSON.parse(pipeInfo.points);
        let potList = points.map(item => {
            let point = [item.x, item.y, item.z];
            return point;
        });
        let BlackHole3D = window.BlackHole3D;
        let shpTextInfo = new BlackHole3D.REShpTextInfo();
        shpTextInfo.text = "测试画线";
        shpTextInfo.texBias = [1, 0];
        shpTextInfo.fontName = "RealBIMFont001";
        shpTextInfo.textClr = new BlackHole3D.REColor(255, 255, 255, 255);
        shpTextInfo.textBorderClr = new BlackHole3D.REColor(0, 0, 0, 128);
        shpTextInfo.textBackMode = 2;
        shpTextInfo.textBackBorder = 2;
        shpTextInfo.textBackClr = new BlackHole3D.REColor(0, 0, 0, 128);

        //矢量线信息
        let lineShpInfo = new BlackHole3D.RELineShpInfo();
        lineShpInfo.shpName = "中心线";
        lineShpInfo.potList = potList;
        lineShpInfo.fillState = 0;
        lineShpInfo.lineClr = new BlackHole3D.REColor(255, 0, 0, 255);
        lineShpInfo.fillClr = new BlackHole3D.REColor(255, 255, 255, 128);
        lineShpInfo.textPos = -2;
        lineShpInfo.scrASDist = -1.0;
        lineShpInfo.scrVisDist = 300.0;
        lineShpInfo.contactSce = true;
        lineShpInfo.lineWidth = 2;
        lineShpInfo.textInfo = shpTextInfo;

        BlackHole3D.Geometry.addPolylineShp(lineShpInfo);
    }

    calcProgress(hugeMBlockNum) {
        // 生成中心线时存在hugeMBlockNum为0的情况，此时中心线直接生成成功，因此做如下处理
        if (hugeMBlockNum === 0) return 100;

        this.hugeMBlockNumMax = hugeMBlockNum > this.hugeMBlockNumMax ? hugeMBlockNum : this.hugeMBlockNumMax;
        let leaveHugeMBlockNum = this.hugeMBlockNumMax - hugeMBlockNum;
        let currProgress = leaveHugeMBlockNum / this.hugeMBlockNumMax;
        currProgress = (Math.round(currProgress * 10000) / 100);
        if (currProgress > this.currProgress) {
            this.currProgress = currProgress;
            return currProgress;
        } else {
            return this.currProgress
        }
    }

    onCanvasMouseMove(event) {
        this.mouseMoveCallBack(event)
    }
}

export default Texture;